import AbstractModel from '../abstract'
import Auth from '@/services/auth.js'

class CurrentUser extends AbstractModel{

  //- Get Role for current user
  getRole() {
    let role = 'none'

    if (this.data && this.data.userrole) {
      role = this.data.userrole.role
    }

    return role
  }

  //- Base auth function
  async can(obj,act) {
    let res = await Auth.enforce(String(this.data.id), obj, act)
    return res
  }
}

export default CurrentUser